import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';
import { TaskState, VhsTaskStatus } from '@schema';
import appConfig from '@/common/appConfig';
import { NotificationType } from '@/common/constants/common.constants';

export { NotificationType };

export const NOTIFICATION_TYPES = [
  NotificationType.WARNING,
  NotificationType.ERROR,
  NotificationType.INFO,
  NotificationType.SUCCESS,
  NotificationType.PROGRESS
];

export const NOTIFICATION_CENTER_FILTER_TYPES = [
  NotificationType.ALL,
  NotificationType.ERROR,
  NotificationType.INFO,
  // NotificationType.WARNING,
  NotificationType.SUCCESS
];

export const NOTIFICATION_ICONS = {
  [NotificationType.WARNING]: {
    name: 'exclamation-triangle',
    color: 'fixed-warning'
  },
  [NotificationType.ERROR]: {
    name: 'times-circle',
    color: 'fixed-danger'
  },
  [NotificationType.SUCCESS]: {
    name: 'check-circle',
    color: 'fixed-success'
  },
  [NotificationType.INFO]: {
    name: 'exclamation-circle',
    color: 'brand-primary'
  },
};

export const NOTIFICATION_TYPE_LABELS = computedLocale(() => ({
  [NotificationType.ALL]: i18n.t('All types'),
  [NotificationType.WARNING]: i18n.t('Warning'),
  [NotificationType.ERROR]: i18n.t('Error'),
  [NotificationType.SUCCESS]: i18n.t('Success'),
  [NotificationType.INFO]: i18n.t('Info'),
}));

export const NOTIFICATIONS_CONFIG = {
  [NotificationType.WARNING]: {
    duration: appConfig.notificationDuration[NotificationType.WARNING],
    showClose: true
  },
  [NotificationType.ERROR]: {
    duration: appConfig.notificationDuration[NotificationType.ERROR],
    showClose: true
  },
  [NotificationType.SUCCESS]: {
    duration: appConfig.notificationDuration[NotificationType.SUCCESS],
    showClose: true
  },
  [NotificationType.INFO]: {
    duration: appConfig.notificationDuration[NotificationType.INFO],
    showClose: false
  },
  [NotificationType.PROGRESS]: {
    duration: appConfig.notificationDuration[NotificationType.PROGRESS],
    showClose: true
  },
};

export const TASK_STATE_TO_NOTIFICATION_TYPE_MAP: Partial<Record<TaskState, NotificationType>> = {
  [TaskState.ABORTED]: NotificationType.ERROR,
  [TaskState.CANCELLED]: NotificationType.WARNING,
  [TaskState.CANCELLING]: NotificationType.PROGRESS,
  [TaskState.FAILED]: NotificationType.ERROR,
  [TaskState.RUNNING]: NotificationType.PROGRESS,
  [TaskState.SCHEDULED]: NotificationType.PROGRESS,
  [TaskState.STARTING]: NotificationType.PROGRESS,
  [TaskState.SUCCESS]: NotificationType.SUCCESS
};

export const VHS_TASK_STATUS_TO_NOTIFICATION_TYPE_MAP: Partial<Record<VhsTaskStatus, NotificationType>> = {
  [VhsTaskStatus.COMPLETED]: NotificationType.SUCCESS,
  [VhsTaskStatus.CANCELLED]: NotificationType.WARNING,
  [VhsTaskStatus.FAILED]: NotificationType.ERROR,
  [VhsTaskStatus.RUNNING]: NotificationType.PROGRESS,
  [VhsTaskStatus.PENDING]: NotificationType.PROGRESS
};

export const COPY_NOTIFICATION_DURATION = 1500;
